var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import * as R from 'ramda';
import { FormBaseElement, FormUtils, ExtraActionType, } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { FileUpload } from 'primereact/fileupload';
var AttachmentControl = /** @class */ (function (_super) {
    __extends(AttachmentControl, _super);
    function AttachmentControl(props) {
        var _this = _super.call(this, props) || this;
        _this.fileuploadRef = null;
        _this.handleRequest = function (_a) {
            var xhr = _a.xhr;
            var headers = R.toPairs(_this.headers);
            headers.forEach(function (_a) {
                var name = _a[0], value = _a[1];
                return xhr.setRequestHeader(name, "" + value);
            });
            _this.onBusy(true);
        };
        _this.handleUpload = function (_a) {
            var xhr = _a.xhr;
            _this.onBusy(false);
            var response = FormUtils._.str2Json(xhr.responseText);
            var value = typeof response === 'string' ? [{ id: response }] : Array.isArray(response) ? response : [response];
            var errorFile = value.find(function (file) { return !!file.error; });
            if (errorFile) {
                _this.onValidationFail(errorFile.error);
            }
            _this.handleChange(value.filter(function (file) { return !file.error; }));
        };
        _this.handleError = function (_a) {
            var xhr = _a.xhr;
            _this.onBusy(false);
            var msg = xhr.status ? 'Ошибка загрузки файла! ' + xhr.status + ': ' + xhr.statusText : 'Нет соединения!';
            _this.onError(msg);
        };
        _this.onFileSelect = function (event) {
            _this.fileuploadRef.setState({
                msgs: [],
            });
            _this.fileuploadRef.files = _this.fileuploadRef.state.files || [];
            var files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
            var filesSize = R.pipe(R.map(function (file) { return file.size; }), R.sum)(files);
            var multiple = R.path(['def', 'frontOptions', 'multiple'], _this.state);
            if (multiple) {
                var existFiles = R.path(['def', 'frontOptions', 'existFiles'], _this.state);
                filesSize += R.pipe(R.map(function (file) { return file.size; }), R.sum)(existFiles);
            }
            var filesTypes = R.map(function (file) { return file.name.substring(file.name.lastIndexOf('.')); }, files);
            _this.setState({ filesSize: filesSize, filesTypes: filesTypes }, function () {
                R.forEach(function (f) {
                    var file = f;
                    if (!_this.fileuploadRef.isFileSelected(file)) {
                        if (_this.fileuploadRef.validate(file)) {
                            if (_this.fileuploadRef.isImage(file)) {
                                file.objectURL = window.URL.createObjectURL(file);
                            }
                            _this.fileuploadRef.files.push(file);
                        }
                    }
                }, files);
                _this.fileuploadRef.setState({
                    files: _this.fileuploadRef.files,
                }, function () {
                    if (_this.fileuploadRef.hasFiles() && _this.fileuploadRef.props.auto) {
                        _this.fileuploadRef.upload();
                    }
                });
                if (_this.fileuploadRef.hasFiles()) {
                    _this.setError();
                }
                _this.fileuploadRef.clearInputElement();
                var mode = R.path(['def', 'frontOptions', 'mode'], _this.state);
                if (mode === 'basic') {
                    _this.fileuploadRef.fileInput.style.display = 'none';
                }
            });
        };
        _this.onValidate = function (file) {
            var maxFileSize = R.path(['def', 'frontOptions', 'maxFileSize'], _this.state);
            var mode = R.path(['def', 'frontOptions', 'mode'], _this.state);
            var accept = R.path(['def', 'frontOptions', 'accept'], _this.state);
            var acceptArray = R.split(', ', accept).map(function (acceptType) { return acceptType.toLowerCase(); });
            if (!!(_this.state.filesTypes || []).find(function (type) { return acceptArray.indexOf(type.toLowerCase()) === -1; })) {
                var error = "\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0444\u0430\u0439\u043B\u043E\u0432 \u0441 \u0442\u0438\u043F\u043E\u043C " + accept;
                _this.onValidationFail(error);
                return false;
            }
            if (!_this.state.filesSize) {
                _this.onValidationFail('Файл имеет недопустимую длину: 0 байт (пустой)');
                return false;
            }
            if (maxFileSize && _this.state.filesSize > maxFileSize) {
                if (mode === 'advanced') {
                    var invalidFileSizeMessageSummary = R.path(['def', 'frontOptions', 'invalidFileSizeMessageSummary'], _this.state);
                    var invalidFileSizeMessageDetail = R.path(['def', 'frontOptions', 'invalidFileSizeMessageDetail'], _this.state);
                    var message = {
                        severity: 'error',
                        summary: invalidFileSizeMessageSummary.replace('{0}', file.name),
                        detail: invalidFileSizeMessageDetail.replace('{0}', _this.fileuploadRef.formatSize(maxFileSize)),
                    };
                    _this.fileuploadRef.messagesUI.show(message);
                }
                else {
                    var multiple = R.path(['def', 'frontOptions', 'multiple'], _this.state);
                    var maxSizeMb = Math.floor((maxFileSize / 1024 / 1024) * 100) / 100;
                    var error = multiple
                        ? "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043C \u0444\u0430\u0439\u043B\u043E\u0432. \u0421\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043C \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C " + maxSizeMb + "\u041C\u0431"
                        : "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430: " + maxSizeMb + "\u041C\u0431";
                    _this.onValidationFail(error);
                }
                return false;
            }
            return true;
        };
        _this.onValidationFail = function (error) {
            if (error === void 0) { error = 'Недопустимый файл'; }
            _this.setError(error, function () { return _this.fileuploadRef.clear(); });
        };
        _this.setError = function (errorText, cb) {
            return _this.setState({ errorText: errorText }, function () {
                if (cb) {
                    cb();
                }
                _this.forceUpdate();
            });
        };
        _this.state = __assign(__assign({}, _this.state), { errorText: null });
        return _this;
    }
    Object.defineProperty(AttachmentControl.prototype, "attachment", {
        get: function () {
            return FormUtils._.str2Json(this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "url", {
        get: function () {
            return R.path(['def', 'frontOptions', 'url'], this.state);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "attachmentAttrs", {
        get: function () {
            return R.pipe(R.path(['def', 'frontOptions']), R.pick([
                'mode',
                'multiple',
                'auto',
                'name',
                'uploadLabel',
                'cancelLabel',
                'chooseLabel',
                'accept',
                'maxFileSize',
            ]))(this.state);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachmentControl.prototype, "headers", {
        get: function () {
            var headers = R.path(['def', 'frontOptions', 'headers'], this.state);
            return headers && typeof headers === 'object' ? headers : {};
        },
        enumerable: false,
        configurable: true
    });
    AttachmentControl.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, style = _a.style, className = _a.className, cancelLabel = _a.cancelLabel, chooseLabel = _a.chooseLabel, uploadLabel = _a.uploadLabel, optLabel = _a.label;
        var label = optLabel || def.label;
        return def.hidden ? null : (React.createElement("div", { className: mapElementClass(def.frontOptions) },
            !!label && (React.createElement("label", { className: "attachment-label", htmlFor: def.id, title: label }, label)),
            React.createElement("div", { className: className, style: style, id: def.id },
                React.createElement(FileUpload, __assign({ uploadLabel: uploadLabel || 'Загрузить', cancelLabel: cancelLabel || 'Отменить', chooseLabel: chooseLabel || 'Выбрать', onUpload: this.handleUpload, onError: this.handleError, onBeforeSend: this.handleRequest, name: "file" }, this.attachmentAttrs, { ref: function (ref) {
                        if (ref) {
                            ref['fileInput'].setAttribute('field-code', def.code);
                            _this.fileuploadRef = ref;
                            ref.validate = _this.onValidate;
                            ref.onFileSelect = _this.onFileSelect;
                        }
                    }, url: this.url, key: def.id, disabled: def.disabled }))),
            React.createElement(ControlError, { error: this.error, touched: this.touched }),
            !!this.state.errorText && React.createElement(ControlError, { error: this.state.errorText, touched: true })));
    };
    AttachmentControl.prototype.onBusy = function (loading) {
        this.props.onEvent({ type: ExtraActionType.LOADING, target: this.state.def, data: loading });
    };
    AttachmentControl.prototype.onError = function (data) {
        this.props.onEvent({ type: ExtraActionType.ERROR, target: this.state.def, data: data });
    };
    return AttachmentControl;
}(FormBaseElement));
export { AttachmentControl };
//# sourceMappingURL=Attachment.js.map